import { useMemo } from 'react';

export type BroswerType = 'chrome' | 'firefox' | 'safari' | 'opera' | 'edge' | null;
export const useBrowserInfo = () => {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
  return useMemo(() => {
    if (userAgent) {
      let browserName: BroswerType;
      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = 'chrome';
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = 'firefox';
      } else if (userAgent.match(/safari/i)) {
        browserName = 'safari';
      } else if (userAgent.match(/opr\//i)) {
        browserName = 'opera';
      } else if (userAgent.match(/edg/i)) {
        browserName = 'edge';
      } else {
        browserName = null;
      }
      return browserName;
    }
    return null;
  }, [userAgent]);
};
